const f = function(t, o) {
  let e = {};
  if (t)
    if (t.ApiConfigService)
      ({ ApiConfigService: e } = t);
    else
      return t.ApiConfigService = e, o(e);
  return e;
}(
  typeof window == "object" && window || typeof globalThis == "object" && globalThis || void 0,
  function(t) {
    let o = "", e = {};
    const n = () => o, l = (i) => {
      o = i;
    }, r = () => e, s = (i, p) => {
      e[i] = p;
    }, c = (i) => {
      e = i;
    };
    return t.getBaseUrl = n, t.setBaseUrl = l, t.getTuples = r, t.addTuple = s, t.setTuples = c, t;
  }
);
export {
  f as i
};
//# sourceMappingURL=ApiConfig-94f64520.mjs.map
